import React from "react";
import { StyleSheet } from "react-native";
import { InfoCardTextProps } from "../../../types/types";
import { MD3Theme, useTheme } from "react-native-paper";
import { Text } from "../../../utils/fontsLoader";

export default function BookingIDText({ title = null, text = null }: InfoCardTextProps) {
  const theme = useTheme();
  const styles = genStyles(theme);

  return (
    <>
      {title && <Text style={styles.title}>
        {title}
      </Text>
      }
      {text &&
        <Text selectable style={styles.text}>
          {text}
        </Text>
      }
    </>
  );
}

const genStyles = (theme: MD3Theme) => StyleSheet.create({
  title: {
    fontFamily: "NotoSans-Bold",
    fontSize: 20,
    padding: 5,
    textAlign: "center",
  },
  text: {
    color: theme.colors.primary,
    //backgroundColor:theme.colors.background,
    fontSize: 25,
    letterSpacing:2,
    fontFamily: "NotoSans-Bold",
    borderColor: "rgba(0, 0, 0, 0.4)",
    //borderWidth: 1.5,
    borderRadius: 10,
    overflow:"hidden",
    padding: 10,
    textAlign: "center",
  }
});